import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { ProfileRouter } from './profile.router';
import { reducers } from './state/profile.selectors';

@NgModule({
  imports: [
    ProfileRouter,
    StoreModule.forFeature('profile', reducers),
  ],
  declarations: []
})
export class ProfileScreenModule { }